import type { SVGProps } from "react";

function IconBase(props: SVGProps<SVGSVGElement>) {
  return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props} />;
}

export function FlameIcon(props: SVGProps<SVGSVGElement>) {
  return <IconBase {...props}><path d="M13.2 2.8c.3 3.4-2.5 4.7-2.5 7.2 0 1.1.6 1.9 1.6 2.4-.1-2.1 1.5-3.4 3-4.7 1.8 1.9 3 4.2 3 6.8A6.4 6.4 0 0 1 12 21a6.4 6.4 0 0 1-6.3-6.5c0-4.1 2.7-7.2 7.5-11.7Z"/><path d="M12.2 20.8c-1.8-.7-2.8-2-2.8-3.6 0-1.8 1.2-3.2 2.8-4.5.1 1.7 1.6 2.2 1.6 4 0 1.8-.8 3.1-1.6 4.1Z"/></IconBase>;
}

export function PauseIcon(props: SVGProps<SVGSVGElement>) {
  return <IconBase {...props}><path d="M8 5v14M16 5v14" /></IconBase>;
}

export function PlayIcon(props: SVGProps<SVGSVGElement>) {
  return <IconBase {...props}><path d="m8 5 11 7-11 7V5Z" /></IconBase>;
}

export function CloseIcon(props: SVGProps<SVGSVGElement>) {
  return <IconBase {...props}><path d="m6 6 12 12M18 6 6 18" /></IconBase>;
}

export function InfoIcon(props: SVGProps<SVGSVGElement>) {
  return <IconBase {...props}><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01" /></IconBase>;
}

export function ConnectionIcon(props: SVGProps<SVGSVGElement>) {
  return <IconBase {...props}><path d="M5 17a10 10 0 0 1 14 0M8 13a6 6 0 0 1 8 0M11 9.5a2 2 0 0 1 2 0"/><circle cx="12" cy="19" r=".8" fill="currentColor" stroke="none"/></IconBase>;
}

export function ExternalLinkIcon(props: SVGProps<SVGSVGElement>) {
  return <IconBase {...props}><path d="M14 5h5v5M19 5l-8 8"/><path d="M18 13v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/></IconBase>;
}

export function ParachuteIcon(props: SVGProps<SVGSVGElement>) {
  return <IconBase {...props}><path d="M4 10a8 8 0 0 1 16 0H4Z"/><path d="m4 10 6 7M20 10l-6 7M12 10v7"/><path d="M9.5 17h5l-.8 4h-3.4l-.8-4Z"/></IconBase>;
}

export function HealthIcon(props: SVGProps<SVGSVGElement>) {
  return <IconBase {...props}><path d="M12 3 5 6v5c0 4.6 2.6 7.8 7 10 4.4-2.2 7-5.4 7-10V6l-7-3Z"/><path d="m9 12 2 2 4-5"/></IconBase>;
}

export function WarningIcon(props: SVGProps<SVGSVGElement>) {
  return <IconBase {...props}><path d="M12 3 2.8 20h18.4L12 3Z"/><path d="M12 9v5M12 17h.01"/></IconBase>;
}
